//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import goodsDetailInfo from './goodsDetailInfo'
export default {
  components: {
    goodsDetailInfo
  },
  data() {
    return {
      showKpmx: false,
      isInvoiceStatus: false,
      submitLoading: false,
      invoiceContent: "",
      chargeList: []
    };
  },
  computed: {
    invoiceInfoData() {
      let invoiceInfoData = JSON.parse(this.$route.query.invoiceData);
      this.showKpmx = invoiceInfoData.settType == "1" ? false : true ;
      invoiceInfoData.invoiceStatus =
        invoiceInfoData.invoiceStatus == "0" ? "未开发票" : invoiceInfoData.invoiceStatus == "1"?"已开发票": invoiceInfoData.invoiceStatus == "3"?"开票中":"开票失败";
      let num = 0;
      invoiceInfoData.chargeDetailList.forEach((k, j) => {
          this.chargeList[num]=k;
          num++;
        })
      return invoiceInfoData;
    }
  },
  methods: {
    confirmSubmit() {
      let invoiceInfoData = JSON.parse(this.$route.query.invoiceData);
      this.$request({
        url: "h5Invoice/queryInvoiceDetailByBillId ",
        data: {
          billId: invoiceInfoData.id
        }
      }).then(res => {
        if (res.pdfPath1) {
          window.location.href = res.pdfPath2;
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/invoice-detail/invoice-detail.vue